import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import CookieBanner from "@/components/CookieBanner";
import SEO from "@/components/SEO";
import { ConfirmDialogProvider } from "@/components/ConfirmDialog";
import Portfolio from "@/pages/Portfolio";
import Login from "@/pages/Login";
import PressKit from "@/pages/PressKit";
import Privacy from "@/pages/Privacy";
import Intros, { IntroThankYou } from "@/pages/Intros";
import Endorsements from "@/pages/Endorsements";
import EndorseForm from "@/pages/EndorseForm";
import DashboardLayout from "@/components/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import Contacts from "@/pages/dashboard/Contacts";
import Deals from "@/pages/dashboard/Deals";
import Tasks from "@/pages/dashboard/Tasks";
import Interactions from "@/pages/dashboard/Interactions";
import AIAssistant from "@/pages/dashboard/AIAssistant";
import Messages from "@/pages/dashboard/Messages";
import Calendar from "@/pages/dashboard/Calendar";
import AdminIntros from "@/pages/dashboard/AdminIntros";
import AdminEndorsements from "@/pages/dashboard/AdminEndorsements";
import Investors from "@/pages/dashboard/Investors";
import Pipeline from "@/pages/dashboard/Pipeline";
import DemoManager from "@/pages/dashboard/DemoManager";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ConfirmDialogProvider>
            <SEO />
          <Routes>
            <Route path="/" element={<Portfolio />} />
            <Route path="/press" element={<PressKit />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/intros" element={<Intros />} />
            <Route path="/intros/thank-you" element={<IntroThankYou />} />
            <Route path="/endorsements" element={<Endorsements />} />
            <Route path="/endorse" element={<EndorseForm />} />
            <Route path="/endorse/:token" element={<EndorseForm />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Overview />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="deals" element={<Deals />} />
              <Route path="investors" element={<Investors />} />
              <Route path="pipeline" element={<Pipeline />} />
              <Route path="demo" element={<DemoManager />} />
              <Route path="tasks" element={<Tasks />} />
              <Route path="calendar" element={<Calendar />} />
              <Route path="interactions" element={<Interactions />} />
              <Route path="messages" element={<Messages />} />
              <Route path="intros" element={<AdminIntros />} />
              <Route path="endorsements" element={<AdminEndorsements />} />
              <Route path="ai" element={<AIAssistant />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieBanner />
          </ConfirmDialogProvider>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
